export const userObject = () => {
  return {
    userDetails: {
      ipAddress: '',
    }
  }
}